import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Spinner, TypeActionForSpinner }         from '@shared/classes/spinner';
import { FeatureSpinnerEnum }                    from '@shared/enums/featureSpinner.enum';
import { throwError }                            from '@shared/helper/LDHelper';
import { ISpinnerState, spinnerAdapter }         from '../state/spinner.state';

const spinnerState = createFeatureSelector<ISpinnerState> ('spinner');


export const selectLoading = createSelector (
  spinnerState,
  (state: ISpinnerState) => spinnerAdapter.getSelectors ().selectAll (state.loading),
);

export const selectLoadingByKey = (feature: FeatureSpinnerEnum) => createSelector (
  selectLoading, (spinner: Spinner[]): TypeActionForSpinner => {
    const result = spinner.filter (t => t.feature === feature);
    if (result.length > 1) {
      throwError (`nb feature for spinner si more than one  - key [${feature}]`);
    }
    return result.length === 1 ? result[0].action : 'EMPTY';
  },
);
